/* eslint-disable */
import { useState } from 'react';
import { Mail, Share } from 'lucide-react';
import { FaLinkedin, FaWhatsapp } from "react-icons/fa";
import { FaFacebook, FaXTwitter } from 'react-icons/fa6';
import { message } from 'antd';

const Whatsapp = FaWhatsapp as any;
const Facebook = FaFacebook as any;
const Twitter = FaXTwitter as any;
const Linkedin = FaLinkedin as any;

export const SocialShare = ({
    slug,
    title,
    description,
    showLabel = true,
    size = 20
}: SocialShareProps) => {
    const [copied, setCopied] = useState(false);

    const iconStyle = {
        color: '#6C6C77',
        width: size,
        height: size,
        transition: 'all 0.2s ease'
    };

    // Construction de l'URL complète
    const getShareUrl = () => {
        if (typeof window === 'undefined') return '';
        const baseUrl = window.location.origin;
        const path = slug.startsWith('/') ? slug : `/${slug}`;
        return `${baseUrl}${path}`;
    };

    const shareUrls = {
        facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(getShareUrl())}`,
        twitter: `https://twitter.com/intent/tweet?text=${encodeURIComponent(title)}&url=${encodeURIComponent(getShareUrl())}`,
        linkedin: `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(getShareUrl())}&title=${encodeURIComponent(title)}&summary=${encodeURIComponent(description)}`,
        whatsapp: `https://wa.me/?text=${encodeURIComponent(`${title} - ${getShareUrl()}`)}`,
        email: `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(`Je pense que cet article pourrait vous intéresser :\n\n${title}\n${getShareUrl()}\n\n${description}`)}`,
    };

    const openSharePopup = (url: string, width = 600, height = 400) => {
        const left = (window.innerWidth - width) / 2;
        const top = (window.innerHeight - height) / 2;
        window.open(url, '_blank', `width=${width},height=${height},left=${left},top=${top}`);
    };

    const copyToClipboard = async () => {
        try {
            await navigator.clipboard.writeText(getShareUrl());
            setCopied(true);
            message.info('Lien copié dans le presse-papiers', 2)
        } catch (err) {
            console.error('Erreur lors de la copie :', err);
        }
    };

    const socialButtons = [
        { name: 'Facebook', icon: Facebook, handler: () => openSharePopup(shareUrls.facebook), color: '#1877f2' },
        { name: 'X', icon: Twitter, handler: () => openSharePopup(shareUrls.twitter), color: '#000000' },
        { name: 'LinkedIn', icon: Linkedin, handler: () => openSharePopup(shareUrls.linkedin, 600, 600), color: '#0a66c2' },
        { name: 'WhatsApp', icon: Whatsapp, handler: () => window.open(shareUrls.whatsapp, '_blank'), color: '#25D366' },
        { name: 'Email', icon: Mail, handler: () => window.location.href = shareUrls.email, color: '#ea4335' },
    ];

    return (
        <div className="social-sharing py-3">
            {showLabel && (
                <p className="text-secondary small mb-2">
                    <strong>Partagez sur </strong>
                </p>
            )}

            <ul className="list-unstyled d-flex gap-3 align-items-center">
                {socialButtons.map((social) => (
                    <li key={social.name}>
                        <a
                            href="#"
                            style={iconStyle}
                            aria-label={social.name}
                            className="social-icon"
                            onMouseEnter={(e) => {
                                e.currentTarget.style.color = social.color;
                                e.currentTarget.style.transform = 'translateY(-2px)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.color = '#6C6C77';
                                e.currentTarget.style.transform = 'translateY(0)';
                            }}
                            onClick={(e) => {
                                e.preventDefault();
                                social.handler();
                            }}
                        >
                            <social.icon size={size} />
                        </a>
                    </li>
                ))}

                {/* Bouton copier le lien */}
                <li>
                    <a
                        href="#"
                        style={iconStyle}
                        aria-label="Copier le lien"
                        className="social-icon"
                        onClick={(e) => {
                            e.preventDefault();
                            copyToClipboard();
                        }}
                    >
                        <Share size={size} />
                    </a>
                </li>
            </ul>
        </div>
    );
};